import React from 'react';
import "./firebase";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Dashboard from './Login/Dashboard';
import AdmissionForm from './Login/AdmissionForm'; // Add this import
import { AuthProvider } from "./Login/AuthContext";
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './components/Auth/ResetPasswordPage';
import ForgotPassword from './components/Auth/ForgotPassword';
// import PrivateRoute from "./Login/PrivateRoute";
import DirectWalkin from './components/DirectWalkin';
import Dashboard from './pages/Dashboard';
import ViewEmployees from "./pages/Employee/ViewEmployees";
import WalkinDashboard from "./pages/WalkinDashboard";
// import WalkinDashboard from "./components/WalkinDashboard/WalkinDashboard";
// import PaymentRecords from './pages/PaymentRecords';
import RoleProtectedRoute from "./Login/RoleProtectedRoute";
import NotAuthorized from './pages/NotAuthorized';
import { ToastProvider } from './components/Admissionform/ToastManager';
import PaymentRecords from './Login/PaymentRecords';
import Staffboard from './pages/Staffboard';
import PasswordResetAdmin from './pages/PasswordResetAdmin';
import LandingPage from './pages/LandingPage';
import PendingFees from './pages/PendingFees';
import AttendancePage from './pages/AttendancePage';
// import StudentProfile from './Login/StudentProfile';
import Coursecomdb from './pages/Coursecomdb';
import OldAdmissionForm from './Login/OldAdmissionForm';
import OldStudentdb from './pages/OldStudentdb';
import Placementdb from './pages/Placementdb';
// import PlacementOfficer from './pages/PlacementOfficer';
import PlacementRedirect from './pages/PlacementRedirect';
import Oldredirect from './Login/Oldredirect';
import Placementupcoming from './pages/Placementupcoming';
import CompanyMap from './pages/CompanyMap';
import MatchedStudents from './pages/MatchedStudents';
import CompanyNotifications from './pages/CompanyNotifications';
import PasswordSetup from './components/Auth/PasswordSetup';
import StudentPasswordReset from './pages/StudentPasswordReset';
import StudentEntryForm from './pages/StudentEntryForm';
import DashboardPage from './pages/DashboardPage';
import Editstudentrecordpage from './pages/Editstudentrecordpage';
import StudentPage from './pages/Studentpage';
import Editstudentrecordpagepp from './pages/Editstudentrecordpagepp';
import PlacedStudent from './pages/PlacedStudent';
import PlacedStudentsReport from './pages/PlacedStudentsReport';
import Jobreq from './pages/Jobreq';
import JobDashboard from './pages/JobDashboard';
import Jobdet from './pages/Jobdet';
import StudentNotificationsPage from "./components/Notifications/StudentNotificationsPage";
import StaffPage from './pages/StaffPage';
import ReportsDashboard from './pages/ReportsDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastProvider>
          <Routes >
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forget" element={<ForgotPassword />} />
            <Route path="/password/reset/:userType/:id/:token" element={<ResetPasswordPage />} />
            <Route path="/stu-dashboard" element={<StudentPage />} />
            <Route path="/direct-walkin" element={<DirectWalkin />} />
            <Route path="/placementofficer" element={<Jobreq />} />
            <Route path="/placementpassed" element={<PlacementRedirect />} />
            <Route path="/placementredirect" element={<Placementupcoming />} />
            <Route path="/oldredirect" element={<Oldredirect />} />
            <Route path="/company-map" element={<CompanyMap />} />
            <Route path="/matched-students" element={<MatchedStudents />} />
            <Route path="/company-notifications" element={<CompanyNotifications />} />
            <Route path="/setup-password" element={<PasswordSetup />} />
            <Route path="/student-resetdefaultpassword" element={<StudentPasswordReset />} />
            <Route path="/student-form" element={<StudentEntryForm />} />
            <Route path="/students-form" element={<DashboardPage />} />
            <Route path="/edits-student/:id" element={<Editstudentrecordpagepp />} />
            <Route path="/placement-report" element={<PlacedStudentsReport />} />
            <Route path="/job-dashboard" element={<JobDashboard />} />
            <Route path="/edit-job/:jobReqId" element={<Jobdet />} />
            <Route path="/placedready" element={<PlacedStudent />} />
            {/* <Route path="/student/notifications" element={<StudentNotificationsPage />} /> */}
            <Route path="/reports" element={<ReportsDashboard />} />
            {/* Role Protected Routes */}
            <Route element={<RoleProtectedRoute allowedRoles={['bde', 'super-admin', 'branch-head']} />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admission-form" element={<AdmissionForm />} />
              <Route path="/pending-records" element={<PendingFees />} />
              <Route path="/walkin-dashboard" element={<WalkinDashboard />} />
            </Route>

            <Route element={<RoleProtectedRoute allowedRoles={['super-admin', 'branch-head']} />}>
              <Route path="/employees" element={<ViewEmployees />} />
              <Route path="/payment-records" element={<PaymentRecords />} />
              <Route path="/landingpage" element={<LandingPage />} />
            </Route>

            <Route element={<RoleProtectedRoute allowedRoles={['super-admin']} />}>
              <Route path="/defaultpassword" element={<PasswordResetAdmin />} />
            </Route>
            <Route element={<RoleProtectedRoute allowedRoles={['placement officer', 'super-admin', 'branch-head']} />}>
              <Route path="/placementdb" element={<Placementdb key="placementEligible" type="placementEligible" />} />
            </Route>

            <Route element={<RoleProtectedRoute allowedRoles={['trainer', 'Trainer', 'super-admin', 'branch-head']} />}>
              <Route path="/staff-dashboard" element={<Placementdb  key="getAll" type="getAll" />} />
              <Route path="/edit-student/:id" element={<Editstudentrecordpage />} />


              <Route path="/old-student-dashboard" element={<Placementdb key="mentor" type="mentor" />} />
              <Route path="/attendance/:student_id/:student_name" element={<AttendancePage />} />
            </Route>
            <Route element={<RoleProtectedRoute allowedRoles={['trainer', 'bde', 'super-admin', 'branch-head']} />}>
              <Route path="/oldadmission-form" element={<OldAdmissionForm />} />
              <Route path="/course-completed" element={<Coursecomdb />} />

            </Route>

            {/* Fallback and Not Authorized */}
            <Route path="/not-authorized" element={<NotAuthorized />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </ToastProvider >
      </Router >
    </AuthProvider >

  );
}

export default App;